// On the backend, a conversation's title is required to be case-insensitively unique
// to a form submission.  Titles are also "squished", removing extra whitespace.
// See app/models/conversation.rb
//
// This function takes a title and transforms it to support frontend validations.
export const canonicalTitle = (title) => title?.trim().replace(/\s+/g, " ").toLowerCase()
